import { render, staticRenderFns } from "./adjust_editor.vue?vue&type=template&id=6646fd80&scoped=true&"
import script from "./adjust_editor.vue?vue&type=script&lang=js&"
export * from "./adjust_editor.vue?vue&type=script&lang=js&"
import style0 from "./adjust_editor.vue?vue&type=style&index=0&id=6646fd80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646fd80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6646fd80')) {
      api.createRecord('6646fd80', component.options)
    } else {
      api.reload('6646fd80', component.options)
    }
    module.hot.accept("./adjust_editor.vue?vue&type=template&id=6646fd80&scoped=true&", function () {
      api.rerender('6646fd80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/user_editor/adjust_editor.vue"
export default component.exports